import React, { Fragment } from 'react';
import { useAppUser, useConfig } from '@bechtel/client-common';
import { PersonaType } from '@bechtel/types';
import { ForemanDashboardContent } from '~/foreman';
import { useDashboardPermissions } from '@bechtel/client-dashboard-common';
import { SuperintendentDashboardContent } from '~/superintendent';
import { FieldEngineerDashboardContent } from '~/field-engineer';

export const DashboardContent = ({ selectedCrewMember }) => {
  const { user } = useAppUser();
  const { features } = useConfig();
  const {
    canViewForemanDashboard,
    canViewSuperIntendentDashboard,
    canViewSuperAdminDashboard,
    canViewFieldWeldEngineerDashboard,
  } = useDashboardPermissions();
  const crewMember = selectedCrewMember ? selectedCrewMember : user?.crewMember;
  const isDashboardSelectedUser = !!selectedCrewMember;
  const enableProjectMap =
    features?.showMapView &&
    Object.values(user?.project?.projectConfiguration?.projectLocation).every((item) => {
      return item != 0;
    });

  return (
    <Fragment>
      {((!selectedCrewMember && canViewForemanDashboard) ||
        (selectedCrewMember && selectedCrewMember.persona === PersonaType.FOREMAN)) && (
        <ForemanDashboardContent crewMember={crewMember} enableProjectMap={enableProjectMap} />
      )}
      {((!selectedCrewMember && canViewFieldWeldEngineerDashboard) ||
        (selectedCrewMember && selectedCrewMember.persona === PersonaType.FIELD_WELD_ENGINEER)) && (
        <FieldEngineerDashboardContent crewMember={crewMember} enableProjectMap={enableProjectMap} />
      )}
      {((!selectedCrewMember && (canViewSuperIntendentDashboard || canViewSuperAdminDashboard)) ||
        (selectedCrewMember &&
          (selectedCrewMember.persona === PersonaType.GENERAL_FOREMAN ||
            selectedCrewMember.persona === PersonaType.SUPERINTENDENT))) && (
        <SuperintendentDashboardContent
          crewMember={crewMember}
          enableProjectMap={enableProjectMap}
          isDashboardSelectedUser={isDashboardSelectedUser}
        />
      )}
    </Fragment>
  );
};
